var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 85.337,
    fill: "#FFFFFF",
    width: 512,
    height: 341.326
  }), /*#__PURE__*/React.createElement("rect", {
    y: 85.337,
    fill: "#FFFFFF",
    width: 512,
    height: 170.663
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 256,
    fill: "#D80027",
    width: 512,
    height: 170.663
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/pl.9798a68e8696b995e365e1ab892f2949.svg";
export { ForwardRef as ReactComponent };